export default __webpack_public_path__ + "static/media/burger.5644e557.svg";